<template>
  <div id="asider-wrapper">
    <div class="asider-icon">
      <div></div>
    </div>
    <!-- 左边导航栏颜色  background-color="#f78989"-->
    <el-menu :default-active="indexPath" :default-openeds="openeds" :unique-opened='true' class="el-menu-vertical-demo max-height-95" @select="open" @open="handleOpen" @close="handleClose" :collapse="collapse" active-text-color="#5e9af5" text-color="white">
      <!-- 循环遍历列表 -->
      <!-- <template>
        <el-submenu v-for="(item,index) in menuList" :key="index" :index="item.index"  id="icon">
          <template slot="title">
            <i :class="item.icon"></i>
            <span slot="title">{{item.name}}</span>
          </template>
          <router-link v-for="(items,indexs) in item.menuLists" :key="indexs" :to="items.route"  tag="p">
            <el-menu-item :index="items.index" @click="rowClick(items)" v-if="!items.level">
              <span slot="title">{{items.name}}</span>
            </el-menu-item>
            <el-submenu :index="items.index" v-else class="submenu">
              <span slot="title">{{ items.name }}</span>
              <router-link  v-for="(ite,idx) in items.children" :key="idx" :to="ite.route"  tag="p">
                <el-menu-item :index="ite.index" @click="rowClick(ite)"> 
                  <i :class="ite.icon"></i>
                  <span slot="title">{{ite.name}}</span>
                </el-menu-item>
              </router-link>
            </el-submenu>
          </router-link>
        </el-submenu>
      </template> -->
      <router-link v-for="(item,index) in List" :key="index" :to="item.route"  tag="p">
        <el-menu-item :index="item.index">
          <!-- <i :class="item.icon"></i> -->
          <span slot="title">{{ item.name }}</span>
        </el-menu-item>
      </router-link>
    </el-menu>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "asider",
  data() {
    return {
      openeds: [],
      // screenHeight: document.body.clientHeight,
      fullHeight: document.documentElement.clientHeight - 160,
      indexPath: "",
      sessionStorageData: {}, //门店参数集合
      isShow: false,
      search: "",
      rowList: [],
      menuList: [
        {
          name: "系统设置",
          icon: "el-icon-mobile-phone",
          index: "400",
          number: "400",
          id:"100100",
          menuLists: [
            {
              name: "首页",
              icon: "el-icon-s-home",
              route: "/home",
              index: "home",
              number: "400",
              id:"1001001",
            },
            {
              name: "门店参数",
              icon: "el-icon-s-data",
              route: "/storeParameters",
              index: "storeParameters",
              number: "400100",
              id:"1001002",
            },
            {
              name: "微信公众号",
              icon: "el-icon-s-data",
              route: "/tencentAccount",
              index: "tencentAccount",
              number: "400110",
              id:"100103",
            },
            {
              name: "角色档案",
              icon: "el-icon-user",
              route: "/role",
              index: "role",
              number: "400",
              id:"100104",
            },
            {
              name: "权限",
              icon: "el-icon-user",
              route: "/permissions",
              index: "permissions",
              number: "400",
              id:"100104",
            },
          ],
        },
        {
          name: "基础档案",
          icon: "el-icon-menu",
          index: "410",
          number: "400",
          id:"200200",
          menuLists: [
            {
              name: "企业档案",
              icon: "el-icon-postcard",
              route: "/qyda",
              index: "300100",
              number: "400",
              listShow: true,
            },
            {
              name: "企业区域档案",
              icon: "el-icon-view",
              route: "/qyqyda",
              index: "300200",
              number: "400",
              listShow: true,
            },
            // {
            //   name: "项目类别",
            //   icon: "el-icon-reading",
            //   route: "/baseProjectType",
            //   index: "baseProjectType",
            //   number: "400400",
            //   id:"2002001",
            // },
            // {
            //   name: "项目",
            //   icon: "el-icon-files",
            //   route: "/baseProject",
            //   index: "baseProject",
            //   number: "400500",
            //   id:"2002002",
            // },
          ],
        },
        {
          name: "员工管理",
          icon: "el-icon-user",
          index: "420",
          number: "400",
          id:"300300",
          menuLists: [
            {
              name: "职务档案",
              icon: "el-icon-user-solid",
              route: "/gradeList",
              index: "gradeList",
              number: "400210",
              id:"3003001",
            },
            {
              name: "工种档案",
              icon: "el-icon-s-custom",
              route: "/jobList",
              index: "jobList",
              number: "400220",
              id:"3003002",
            },
            {
              name: "员工",
              icon: "el-icon-user",
              route: "/baseStaff",
              index: "baseStaff",
              number: "400200",
              id:"3003003",
            },
            {
              name: "员工作品",
              icon: "el-icon-info",
              route: "/staffWorks",
              index: "staffWorks",
              number: "400300",
              id:"3003004",
            },
            {
              name: "服务反馈",
              icon: "el-icon-suitcase",
              route: "/feedback",
              index: "feedback",
              number: "400310",
              id:"3003005",
            },
            {
              name: "消费评价",
              icon: "el-icon-files",
              route: "/evaluation",
              index: "evaluation",
              number: "400320",
              id:"3003006",
            },
          ],
        },
      ],
      List:[
        {
          name: "首页",
          icon: "el-icon-s-home",
          route: "/home",
          index: "home",
          number: "400",
          id:"1001001",
        },
        // {
        //   name: "角色",
        //   icon: "el-icon-user",
        //   route: "/role",
        //   index: "role",
        //   number: "400",
        //   id:"100104",
        // },
        // {
        //   name: "权限",
        //   icon: "el-icon-user",
        //   route: "/permissions",
        //   index: "permissions",
        //   number: "400",
        //   id:"100104",
        // },
        {
          name: "用户",
          icon: "el-icon-user",
          route: "/user",
          index: "user",
          number: "400",
          id:"100104",
        },
        {
          name: "部门",
          icon: "el-icon-view",
          route: "/dept",
          index: "dept",
          number: "400",
          listShow: true,
        },
        {
          name: "已入场记录",
          icon: "el-icon-user",
          route: "/baseStaff",
          index: "baseStaff",
          number: "400200",
          id:"3003003",
        },
        {
          name: "待入场记录",
          icon: "el-icon-view",
          route: "/codeJob",
          index: "codeJob",
          number: "400",
          listShow: true,
        },
        // {
        //   name: "协议",
        //   icon: "el-icon-view",
        //   route: "/memberAgreement",
        //   number: "400",
        //   listShow: true,
        // },
        {
          name: "临时工考勤记录",
          icon: "el-icon-view",
          route: "/staffAttendance",
          index: "staffAttendance",
          number: "400",
          listShow: true,
        },
        {
          name: "北森失败记录",
          icon: "el-icon-view",
          route: "/errList",
          index: "errList",
          number: "400",
          listShow: true,
        },
        {
          name: "考勤异常记录",
          icon: "el-icon-view",
          route: "/errAttendance",
          index: "errAttendance",
          number: "400",
          listShow: true,
        },
        {
          name: "临时工修改记录",
          icon: "el-icon-view",
          route: "/updateList",
          index: "updateList",
          number: "400",
          listShow: true,
        }
      ]
    };
  },
  computed: {
    ...mapState(["collapse"]),
  },
  methods: {
    rowClick(row) {
      if (this.rowList.length < 9) {
        let flag = true;
        this.rowList.forEach((item) => {
          if (row.index == item.index) {
            flag = false;
          }
        });
        if (flag) {
          this.rowList.push(row);
        }
      } else {
      }
    },
    handleOpen(key, keyPath) {
      //console.log(key, keyPath);
      sessionStorage.setItem("keyPath", key);
    },
    handleClose(key, keyPath) {
      //console.log(key, keyPath);
    },
    open(index) {
      sessionStorage.setItem("indexPath", index);
    },
    //菜单收放事件
    handleChangeCollapse(show) {
      this.$store.dispatch("actionChange", !this.collapse);
      this.isShow = !this.isShow;
    },
  },
  created() {
    // 只在总店显示
    // if(sessionStorage.getItem("headOffice") * 1 == 1){ //总店
    //   this.menuList[3].menuLists.push({
    //     name: "会员疗程卡包",
    //     icon: "el-icon-receiving",
    //     route: "/memberReatment",
    //     index: "memberReatment",
    //     number: "400700",
    //     id:"800800425",
    //   })
    //   this.menuList[7].menuLists.push({
    //     name: "会员协议",
    //     icon: "el-icon-receiving",
    //     route: "/memberAgreement",
    //     index: "memberAgreement",
    //     number: "500200",
    //     id:"800800423",
    //   })
    //   this.menuList[0].menuLists.push({
    //     name: "短信配置",
    //     icon: "el-icon-receiving",
    //     route: "/smsSetup",
    //     index: "smsSetup",
    //     number: "600100",
    //     id:"800800424",
    //   })
    //   this.menuList[9].menuLists.push(
    //     {
    //       name: "疗程统计表",
    //       icon: "el-icon-suitcase",
    //       route: "/courseStatistics",
    //       index: "courseStatistics",
    //       number: "600900",
    //       id:"1001101",
    //     },
    //   )
    // }
    var that = this;
    let menuList = [...that.menuList];
    setTimeout(() => {
      that.sessionStorageData = JSON.parse(
        sessionStorage.getItem("sessionStorageData")
      );
      that.indexPath = sessionStorage.getItem("indexPath");
      that.openeds.push(sessionStorage.getItem("keyPath"));
      menuList.forEach((item, index) => {
        if (sessionStorage.getItem("headOffice") * 1 != 1) {
          if (item.number == "900") {
            menuList.splice(index, 1);
          }
          item.menuLists.forEach((items, indexs) => {
            if (items.number == "4001200" || items.name == "角色档案") {
              item.menuLists.splice(indexs, 1);
            }
          });
        }
        item.menuLists.forEach((items) => {
          if (
            that.sessionStorageData.allowdebt == false &&
            item.number * 1 == 500 &&
            items.number * 1 == 500800
          ) {
            items.number = "0";
          }
        });
      });
      // 总店下面添加菜单
      // if(sessionStorage.getItem("headOffice") * 1 == 1){
      //   let list = [
      //     {
      //       icon: "el-icon-reading",
      //       index:'partners',
      //       name:'合作商',
      //       number:'400',
      //       menuLists:[
      //         {
      //           index:'parthnersArchives',
      //           name:'合作商档案',
      //           route:'/parthnersArchives',
      //           number:'400'
      //         },
      //         {
      //           index:'partnersProject',
      //           name:'合作项目',
      //           route:'/partnersProject',
      //           number:'400'
      //         },
      //         {
      //           index:'partnersList',
      //           name:'合作报表',
      //           route:'/partnersList',
      //           number:'400'
      //         },
      //       ]
      //     },
      //     // {
      //     //   icon: "el-icon-price-tag",
      //     //   index:'financialReconciliation',
      //     //   name:'财务对账',
      //     //   number:'400',
      //     //   menuLists:[
      //     //     {
      //     //       index:'reconciliation',
      //     //       name:'对账单',
      //     //       route:'/reconciliation',
      //     //       number:'400'
      //     //     },
      //     //   ]
      //     // }
      //   ]
      //   menuList = menuList.concat(list)
      // }
      that.menuList = menuList;

      console.log(that.menuList)
    }, 1000);
  },
  mounted() {
    //console.log(document.body.clientHeight);
    var h = document.documentElement.clientHeight || document.body.clientHeight;
    var a = document.getElementById("asider-wrapper");
    a.style.height = h - 58 + "px"; //减去顶部高度
    a.style.height = document.body.clientHeight + "px";
  },
  watch: {
    $route(to, from) {
      //监听路由 把当前路由的index存到sessionStorage 页面刷新时不该变页面   把index赋值给this.indexPath 实现路由跳转
      sessionStorage.setItem("indexPath", to.meta.index);
      this.indexPath = this.$route.meta.index;
    },
  },
};
</script>

<style scoped>
/deep/.custom-submenu .el-submenu__title {
  height: 50px; 
  line-height: 50px; 
}

.el-menu-item, .el-submenu__title{
  height: 50px;
  line-height: 50px;
}
/* .el-menu-item.is-active i {
  color: #a09f9f;
} */
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-width: 64px;
  /* border-top: #5e9af5 1px solid; */
}

/* 一级菜单字体 */
.el-submenu__title span {
  font-size: 14px;
}

/* 二级菜单字体 */
.el-menu-item {
  font-size: 14px;
}

* /deep/ .el-submenu__title i {
  color: white !important;
}

/* 收缩按钮样式 */
#i i:hover {
  background: #438efd;
}

#icon i {
  color: white;
}

#icons i {
  color: white;
}

#asider-wrapper {
  max-width: 200px;
  min-width: 64px;
  min-height: 940px;
  /* background:rgb(48, 65, 86) */
}

.el-menu {
  border: none;
}

</style>




// WEBPACK FOOTER //
// src/layout/components/asider.vue